import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any
}

interface Users {
    branch_ID?: number,
    login_ID?: number,
    user_Name?: string,
}

interface RowData {
    login_ID: number,
    teamMember_ID: number,
    team_ID: number,
    user_Name: string,
}

export const TeamMembers = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [company, setCompany] = useState(null as ICompanyMastDropdown | null);
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [branch, setBranch] = useState(null as IBranchMastDropdown | null);
    const [users, setUsers] = useState<Array<Users>>();
    const [disableOnSubmit, setDisableOnSubmit] = useState<boolean>(false);
    const [diable, setDisable] = useState({ branch: true, teamMembers: true });
    const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [disableRemove, setDisableRemove] = useState(false);

    const onHide = () => {
        setCompany(null);
        setBranch(null);
        setSelectedTeamMembers([]);
        setDisableRemove(false);
        props.hideDialog();
    };

    const selectCompany = (e: ICompanyMastDropdown) => {
        setCompany(e);
        setBranch(null);
        if (e) {
            setDisable({ branch: false, teamMembers: true });
        } else {
            setDisable({ branch: true, teamMembers: true });
        }
    };
    const selectBranch = (e: IBranchMastDropdown) => {
        setBranch(e);
        if (e) {
            setDisable({ branch: false, teamMembers: false });
        } else {
            setDisable({ branch: false, teamMembers: true });
        }
    }

    const loadCompanies = async () => {
        setBranch(null);
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    };

    const loadBranches = async () => {
        setUsers([]);
        const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${company}`, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranches(data);
        }
    }

    const onSubmit = async () => {
        setDisableOnSubmit(true);
        let newData: any[] = [];
        selectedTeamMembers.forEach(el => {
            newData.push({ Login_ID: el, Team_ID: props.singleData?.team_ID });
        });
        const response = await Fetch(`Allocate_Team_Mast/addTeamMember`, "POST", newData, null, props.toast);
        if (response) {
            // onHide();
            setCompany(null);
            setBranch(null);
            setSelectedTeamMembers([]);
            setDisableRemove(false);
            setDisableOnSubmit(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            loadTeamMembers();
        } else {
            setDisableOnSubmit(false);
        }
    }

    async function removeMember(data: any) {
        setDisableRemove(true);
        const response = await Fetch(`Allocate_Team_Mast/removeTeamMember`, "DELETE", data, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Member Removed", life: 3000 });
            if (data.team_ID) {
                loadTeamMembers();
            }
            setDisableRemove(false);
            return true;
        }
    }

    const MoveRemove = (rowData: RowData) => {
        return (<div className="w-full flex justify-content-evenly">
            <Button className="w-6rem" disabled={disableRemove} onClick={() => removeMember({ team_ID: props.singleData?.team_ID, team_Member_ID: rowData.teamMember_ID })}>Remove</Button>
        </div>);
    }

    const loadTeamMembers = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Allocate_Team_Mast/getTeamMember", "GET", null, `teamID=${props.singleData?.team_ID}`, null);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: true });
    }

    const loadUsers = async () => {
        const response = await Fetch("Dropdown/UsersByBranch", "GET", null, `branch_ID=${branch}`, null);
        if (response) {
            const data: Array<Users> = await response.json();
            let resp = [];
            for (let i = 0; i < data.length; i++) {
                let yes = true;
                for (let j = 0; j < tableData.tableData.length; j++) {
                    if (data[i].login_ID === tableData.tableData[j].login_ID) {
                        yes = false;
                        j = tableData.tableData.length;
                    }
                }
                if (yes) {
                    resp.push(data[i]);
                }
            }
            setUsers(resp);
        }
    }

    useEffect(() => {
        if (company != null) {
            loadBranches();
        }
    }, [company]);
    useEffect(() => {
        if (branch != null) {
            loadUsers();
        }
    }, [branch]);

    useEffect(() => {
        loadCompanies();
        if (props.open && props.singleData?.team_ID) {
            loadTeamMembers();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Team Members" modal className="p-fluid" onHide={onHide}>
            <div className="flex align-content-center mt-6 gap-3">
                <div>
                    <label>Company</label>
                    <Dropdown value={company} onChange={(e: any) => selectCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" placeholder="Select a Company" className="w-full md:w-14rem" showClear />
                </div>
                <div>
                    <label>Branch</label>
                    <Dropdown value={branch} disabled={diable.branch} onChange={(e: any) => selectBranch(e.value)} options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select a Branch" className="w-full md:w-14rem" showClear />
                </div>
            </div>
            <div className="flex align-content-center mt-3 gap-3">
                <MultiSelect value={selectedTeamMembers} disabled={diable.teamMembers} onChange={(e) => setSelectedTeamMembers(e.value)} options={users} optionValue="login_ID" optionLabel="user_Name" display="chip" filter placeholder="Select Members" maxSelectedLabels={10} className="w-11" />
                <Button disabled={disableOnSubmit} className="h-3rem w-6rem" onClick={onSubmit}>SUBMIT</Button>
            </div>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                className="mt-6"
                size="small" stripedRows scrollable scrollHeight="30vh"
                value={tableData.tableData}
                emptyMessage="No Team Members found."
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Team Member Name" />
                <Column field="company" header="Company Name" />
                <Column field="branch" header="Branch Name" />

                <Column field="" header="" body={MoveRemove} />
            </DataTable>
        </Dialog>
    );
}